import { columns } from "../../../../dtos/columns"
import { AccionesCorreccionMonetaria } from "../components/accionesCorreccionMonetaria"
import { RowCorreccionMonetaria } from "../models/rowCorreccionMonetaria"

interface IProps {
    onUpdate: (row: RowCorreccionMonetaria) => void,
    onDelete: (row: RowCorreccionMonetaria) => void
}

export default function UseColumns({onUpdate, onDelete} : IProps){
    
    const COLUMNS: columns<RowCorreccionMonetaria>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesCorreccionMonetaria
                    row={row}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center',
        },
        {
            name: 'Mes',
            selector: (row) => row.mes,
            sortable: true,
            sortField: 'mes',
            wrap: true,
            export: true,
        },
        {
            name: 'Factor',
            selector: (row) => row.factor,
            sortable: true,
            sortField: 'factor',
            wrap: true,
            export: true,
        },
    ]

    return {COLUMNS}
}